import L, { LatLngBounds } from "leaflet";
import type AreaofInterestMapEntity from "../map-entities/area-of-interest-map-entity";

interface GetDefaultBoundsProps {
    aoiEntitiesNearDefaultPosition: AreaofInterestMapEntity[];
}
export const getDefaultBounds = ({ aoiEntitiesNearDefaultPosition }: GetDefaultBoundsProps) => {
    // Collect valid LatLngBounds from entities
    const boundsList = aoiEntitiesNearDefaultPosition
        .map((aoi) => aoi?.leafletElement?.getBounds?.())
        .filter((b) => b && b.isValid());

    // Build combined bounds containing all AOIs
    let parentBounds = undefined as LatLngBounds | undefined;
    boundsList.forEach((b) => {
        if (!parentBounds) {
            parentBounds = new L.LatLngBounds(b.getSouthWest(), b.getNorthEast());
        } else {
            parentBounds = parentBounds.extend(b);
        }
    });
    return parentBounds;
};
